import React from 'react';
import clsx from 'clsx';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  ClaimLogEntryViewCodesDTO,
} from 'dtos';
import Tag from 'core/components/Tag';

type Props = {
  afterStatus?: string | null;
  codes?: ClaimLogEntryViewCodesDTO;
  className?: string;
};

export default function ActivityStatusTag({
  afterStatus,
  codes,
  className,
}: Props) {
  const {
    categoryCode,
    categoryCodeText,
    statusCode,
    statusCodeText,
  } = codes ?? {};
  const codeLabel = [
    categoryCode,
    statusCode,
  ].filter(notEmptyString).join(' / ');
  const label = [
    afterStatus,
    codeLabel,
  ].filter(notEmptyString).join(' · ');
  const tooltipAvailable = notEmptyString(categoryCodeText)
    || notEmptyString(statusCodeText);

  return notEmptyString(label) ? (
    <Tag
      tagName={afterStatus ?? ''}
      tooltip={tooltipAvailable ? (
        <div className="flex flex-col gap-1 max-w-96 text-gray-600 font-semibold p-2">
          {notEmptyString(categoryCodeText) && (
            <div className="flex items-start gap-1">
              <span className="font-semibold">{categoryCode}:</span>
              <span>{categoryCodeText}</span>
            </div>
          )}
          {notEmptyString(statusCodeText) && (
            <div className="flex items-start gap-1">
              <span className="font-semibold">{statusCode}:</span>
              <span>{statusCodeText}</span>
            </div>
          )}
        </div>
      ) : undefined}
      className={clsx('!font-semibold !px-2 !h-5 w-fit', className)}
      defaultColor="!bg-brown-100 !text-brown-600"
    >
      {label}
    </Tag>
  ) : null;
}
